import { AVAILABLE_STATUSES } from '../constants/base';

export default (isAvailableAllStatuses: boolean | undefined, currentStatus: keyof typeof AVAILABLE_STATUSES) =>
  isAvailableAllStatuses ? AVAILABLE_STATUSES.draft : AVAILABLE_STATUSES[currentStatus];
